import React from "react";
import ReplacedCourseField, { ReplacedCourse } from "./index";

export const REPLACED_COURSE_FIELD_TYPE = "replaced-course";
export const EXEMPTED_LEARNING_OBJECT_KEY = "exemptedLearningObjectId";
const TOGGLE_KEY = "replacesPlatformCourse";
const COURSE_KEY = "replacedCourse";

interface CustomFieldContext {
  inputForm: any;
  disabled: boolean;
  setValues: (values: Record<string, any>) => void;
}

interface ReplacedCourseFieldOptions {
  corporateId: string;
  initialExemptedId?: number | string | null;
}

export const toInitialReplacedCourse = (
  exemptedId?: number | string | null,
): ReplacedCourse | null =>
  exemptedId === undefined || exemptedId === null
    ? null
    : { id: Number(exemptedId), title: "" };

export const isReplacingCourse = (
  values: Record<string, any>,
  initial: ReplacedCourse | null = null,
): boolean =>
  values?.[TOGGLE_KEY] ??
  (values?.[COURSE_KEY] !== undefined ? !!values[COURSE_KEY] : !!initial);

export const renderReplacedCourseField =
  ({ corporateId, initialExemptedId }: ReplacedCourseFieldOptions) =>
  (col: any, { inputForm, disabled, setValues }: CustomFieldContext) => {
    if (col.type !== REPLACED_COURSE_FIELD_TYPE) return null;
    const initial = toInitialReplacedCourse(initialExemptedId);
    const selected =
      inputForm?.[COURSE_KEY] !== undefined ? inputForm[COURSE_KEY] : initial;
    return (
      <ReplacedCourseField
        corporateId={corporateId}
        label={col.header}
        enabled={isReplacingCourse(inputForm, initial)}
        selected={selected ?? null}
        disabled={disabled}
        onToggle={(next) => setValues({ [TOGGLE_KEY]: next })}
        onSelect={(next) => setValues({ [COURSE_KEY]: next })}
      />
    );
  };

export const toReplacedCoursePayload = (
  values: Record<string, any>,
): Record<string, any> => {
  const { [TOGGLE_KEY]: toggle, [COURSE_KEY]: course, ...rest } = values;
  return {
    ...rest,
    ...((toggle ?? true) && course?.id != null
      ? { [EXEMPTED_LEARNING_OBJECT_KEY]: course.id }
      : {}),
  };
};
